import _ from 'lodash'

export const getSelectedOrg = (state) => {
  if (state.context.type === "org") {
    var org = _.find(state.org.orgs, {id: state.context.id});
    if (org) return org;
  }
  return {};
};
